module.exports = __webpack_public_path__ + "static/img/edge_img_2.0f23617c.png";